/**
 * @module: 候选人list
 * @author: Yun Tang
 * @date: 2020-06-09 10:21:35 
 */
import { observable, action } from 'mobx';
import { withRole } from '@src/utils/residentNew';
import ywk, { utils } from "@clouderwork/ywk";
import { Toast } from 'antd-mobile';
class Person {
  // 职位列表
  @observable personList: any[] = [];
  // 职位列表数据总数
  @observable total: number = 0;
  // 职位列表查询条件
  @observable filterPramas: any = {};
  // 首次加载
  @observable loading: boolean = true;
  // 加载更多
  @observable refreshing: boolean = false;

  // 设置值
  @action.bound
  setProperyVal(key: string, val: any){
    this[key] = val;
  }

  /** 获取职位列表数据 */
  @action.bound
  async getPersonList(query: any) {
    if (query.pagenum === 1) {
      this.loading = true
    } else {
      this.refreshing = true
    }
    // 企業版來源
    const company = utils.getQueryString("isCompany")
    const res = await ywk.ajax.post('/resident/api/recommend/resumes', withRole({...query, role: company ? 'company' : 'person'}, company ? 1 : 2))
    if (res.error_code === 0) {
      const { total, result } = res;
      if (total > 0) {
        if (query.pagenum === 1) {
          this.personList = result
        } else {
          this.personList = this.personList.concat(result)
        }
      } else {
        this.personList = []
      }
      this.filterPramas = query;
      this.total = total;
    }
    this.loading = false;
    setTimeout(() => {
      this.refreshing = false;
    }, 100)
  }
}

export default Person